<template>
  <svg
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 32 32"
    style="enable-background: new 0 0 32 32;"
    xml:space="preserve"
  >
    <path
      fill="#55acee"
      d="M30.4,7.1C29.3,7.5,28.2,7.9,27,8c1.2-0.7,2.2-1.9,2.6-3.3c-1.1,0.7-2.4,1.2-3.8,1.4c-1.1-1.2-2.6-1.9-4.3-1.9
      c-3.3,0-5.9,2.6-5.9,5.9c0,0.5,0.1,0.9,0.2,1.3c-4.9-0.1-9.3-2.4-12.2-6c-0.5,0.9-0.8,1.9-0.8,3c0,2.1,1,3.9,2.6,4.9
      c-1,0-1.9-0.3-2.7-0.7v0.1c0,2.9,2,5.3,4.7,5.8c-0.5,0.1-1,0.2-1.6,0.2c-0.4,0-0.8,0-1.1-0.1c0.8,2.3,2.9,4.1,5.5,4.1
      c-2,1.6-4.6,2.5-7.3,2.5c-0.5,0-0.9,0-1.4-0.1c2.6,1.7,5.7,2.7,9.1,2.7c10.9,0,16.8-9,16.8-16.8v-0.8C28.6,9.3,29.6,8.3,30.4,7.1z"
    />
  </svg>
</template>

<script>
  export default {
    name: 'Twitter'
  }
</script>
